import { Component, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { MatStepper } from '@angular/material/stepper';
import { CondominiumFormComponent } from '../../shared/condominium-form/condominium-form.component';
import { CondominiumService, CreateCondominiumRequest } from '../../services/condominium.service';
import { SubscriptionPlanSelectorComponent } from '../../shared/subscription-plan-selector/subscription-plan-selector.component';
import { SubscriptionPlanDTO } from '../../services/subscription-plan.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
    selector: 'app-create',
    templateUrl: './create.component.html',
    styleUrls: ['./create.component.sass'],
    standalone: false
})
export class CreateComponent {
  @ViewChild('stepper') stepper?: MatStepper;
  @ViewChild(CondominiumFormComponent) formComp?: CondominiumFormComponent;
  @ViewChild(SubscriptionPlanSelectorComponent) planSelector?: SubscriptionPlanSelectorComponent;

  selectedPlan: SubscriptionPlanDTO | null = null;
  isCreating = false;
  createdCondominiumId: number | null = null;

  constructor(
    private router: Router,
    private condominiumService: CondominiumService,
    private snackBar: MatSnackBar
  ) {}

  onNext(): void {
    if (this.stepper?.selectedIndex === 0) {
      // Primeiro passo: validar formulário
      if (this.formComp && !this.formComp.validateTermsAcceptance()) {
        this.formComp.form.markAllAsTouched();
        return;
      }
      if (this.formComp?.form.invalid) {
        this.formComp.form.markAllAsTouched();
        return;
      }
      this.stepper.next();
    } else if (this.stepper?.selectedIndex === 1) {
      // Segundo passo: criar condomínio
      this.createCondominium();
    }
  }

  onBack(): void {
    if (this.stepper?.selectedIndex === 0) {
      this.router.navigate(['/condominiums']);
    } else {
      this.stepper?.previous();
    }
  }

  onPlanSelected(plan: SubscriptionPlanDTO | null): void {
    this.selectedPlan = plan;
  }

  private createCondominium(): void {
    if (!this.formComp || !this.selectedPlan) {
      return;
    }

    if (this.formComp.form.invalid) {
      this.formComp.form.markAllAsTouched();
      return;
    }

    this.isCreating = true;
    const request: CreateCondominiumRequest = {
      ...this.formComp.form.value,
      phoneNumbers: this.formComp.phoneNumbers.value,
      subscriptionPlan: this.selectedPlan.id
    };

    this.condominiumService.createCondominium(request).subscribe({
      next: (condominium) => {
        this.isCreating = false;
        this.createdCondominiumId = condominium.id;
        this.stepper?.next();
      },
      error: (error: HttpErrorResponse) => {
        this.isCreating = false;
        let errorMessage = 'Erro inesperado. Por favor, tente novamente mais tarde';
        
        if (error.status >= 400 && error.status < 500) {
          // Erro 4xx: usar mensagem do servidor
          if (error.error?.message) {
            errorMessage = error.error.message;
          } else if (error.error?.error) {
            errorMessage = error.error.error;
          } else if (typeof error.error === 'string') {
            errorMessage = error.error;
          } else {
            errorMessage = 'Erro ao criar condomínio';
          }
        }
        // Erro 5xx: usar mensagem padrão (já definida acima)

        this.snackBar.open(errorMessage, 'OK', { duration: 7000 });
      }
    });
  }

  onGoToCondominium(): void {
    if (this.createdCondominiumId != null) {
      this.router.navigate(['/condominium', this.createdCondominiumId]);
    }
  }
}
